import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { RouterPathService } from "../variables/router-path.service";

@Injectable({
    providedIn: 'root'
})
export class DirectAccessGuard implements CanActivate {
    constructor(private router: Router, private routerPath: RouterPathService) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // If the previous URL was blank, then the user is directly accessing this page
        if (this.router.url === '/') {
            this.router.navigate([this.routerPath.manageProjectPath]); // Navigate away to some other page
            return false;
        }
        return true;
    }
}